import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70dfad4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ant-upload-drag-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "ant-upload-drag-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-nova-imagem" }, "Nova imagem", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text ss-produto-nova-imagem-descricao" }, [
  /*#__PURE__*/_createTextVNode("Clique para selecionar ou arraste"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" as imagens até aqui")
], -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-alinhar-centro" }
const _hoisted_13 = { class: "ss-box-produto-imagem-principal" }
const _hoisted_14 = { class: "ss-imagem" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-produto-imagem-principal" }, "Imagem principal", -1))
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_17 = {
  key: 0,
  class: "ss-mover ss-imagem"
}
const _hoisted_18 = { class: "ss-display-flex ss-alinhar-centro" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        (_ctx.props.empresas.length === 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "É necessário selecionar uma empresa antes de enviar as imagens"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selecionarImagemUpload && _ctx.selecionarImagemUpload(...args))),
                  class: "ant-upload ant-upload-drag",
                  onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_4, [
                    _createElementVNode("input", {
                      id: "selecionarImagemProduto",
                      type: "file",
                      accept: "",
                      multiple: "",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enviarImagens && _ctx.enviarImagens(...args))),
                      style: {"display":"none"}
                    }, null, 32),
                    _createElementVNode("div", {
                      class: "ant-upload-drag-container",
                      onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dropImagem && _ctx.dropImagem(...args)))
                    }, [
                      ((_ctx.state.enviandoImagens || _ctx.state.excluindoImagens))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("p", _hoisted_6, [
                              _createVNode(_component_a_spin, { size: "large" })
                            ]),
                            _hoisted_7
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, [
                              _createVNode(_component_icone, {
                                style: {"font-size":"40px"},
                                nome: "upload-nuvem"
                              })
                            ]),
                            _hoisted_10,
                            _createTextVNode(),
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.state.imagemPrincipal,
                              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.imagemPrincipal) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Imagem Principal ")
                              ]),
                              _: 1
                            }, 8, ["checked"]),
                            _hoisted_11
                          ]))
                    ], 32)
                  ])
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_a_image, {
                      width: 200,
                      src: _ctx.obtemImagemPrincipal().imagem,
                      fallback: _ctx.state.imagemBranco
                    }, null, 8, ["src", "fallback"]),
                    _hoisted_15,
                    (_ctx.obtemImagemPrincipal().principal)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          title: "Remover",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmaExclusao(_ctx.obtemImagemPrincipal()))),
                          class: "ss-produto-imagem-remover"
                        }, "Remover"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(), _createBlock(_component_a_image_preview_group, {
                  key: _ctx.state.indexPreview
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.computedImagens,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedImagens) = $event)),
                      "item-key": "imagem",
                      handle: ".ss-mover",
                      class: "ss-produto-imagens"
                    }, {
                      item: _withCtx(({element}) => [
                        ((element.principal === false))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _createVNode(_component_a_image, {
                                width: 105,
                                src: element.imagem
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("a", {
                                  title: "Definir como prinicipal",
                                  onClick: ($event: any) => (_ctx.defineImagemPrincipal(element.imagem)),
                                  class: "ss-produto-imagem-definir-principal"
                                }, "PRINICPAL", 8, _hoisted_19),
                                _createElementVNode("a", {
                                  title: "Remover",
                                  onClick: ($event: any) => (_ctx.confirmaExclusao(element)),
                                  class: "ss-produto-imagem-remover"
                                }, "REMOVER", 8, _hoisted_20)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      footer: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedImagensBranco, (index) => {
                          return (_openBlock(), _createBlock(_component_a_image, {
                            key: index,
                            width: 105,
                            src: "",
                            fallback: _ctx.state.imagemBranco
                          }, null, 8, ["fallback"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}